import { TableCell } from "@mui/material";
import { styled } from "@mui/system";
import { Colors } from "../util/Colors";

export const StyledTableCell = styled(TableCell)({
    backgroundColor: Colors.WHITE,
});
